export default {
    baseStyle: {}
}
